import BootstrapCarousel from 'bootstrap/js/dist/carousel';

export default {
    classType: 'components',

    init() {
        /**
         * We hack a little the Bootstrap's carousel to append N - 1 next
         * elements to each element of the carousel to display N elements and
         * slide them one by one.
         */
        if (this.el.querySelectorAll('.carousel-item').length > 1) {
            // When there is only one item, we skip the copy : it looks like copy-paste
            // and the carousel doesn't seem to start rolling anyway.
            this.el.querySelectorAll('.carousel-item').forEach((el) => {
                const minPerSlide = 3;
                let next = el;
                for (let i = 0; i < minPerSlide - 1; i++) {
                    next = next.nextElementSibling;
                    if (!next) {
                        next = el.parentElement.firstElementChild;
                    }
                    el.appendChild(next.firstElementChild.cloneNode(true));
                }
            });
        }
    },
};
